import { render, staticRenderFns } from "./ApartsList.vue?vue&type=template&id=4a254f07"
import script from "./ApartsList.vue?vue&type=script&lang=js"
export * from "./ApartsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports